// import { AppBar, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Modal, Toolbar, Typography, useTheme } from '@mui/material'
// import React, { memo } from 'react'
// import CloseIcon from '@mui/icons-material/Close';

// function AppModal({ open, handleClose, children }) {
//     const { palette } = useTheme()
//     return (
//         <Dialog fullScreen open={open} onClose={handleClose}>
//             <DialogContent sx={{ padding: 0, margin: 0 }}>
//                 <IconButton size='small' sx={{ display: "flex", marginLeft: "auto", alignSelf: "center" }} onClick={handleClose}>
//                     <CloseIcon />
//                 </IconButton>
//                 {children}
//             </DialogContent>
//         </Dialog>
//     )
// }

// export default memo(AppModal)


import {
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import React, { memo } from "react";
import CloseIcon from "@mui/icons-material/Close";

function AppModal({ open, handleClose, children }) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          height: "100vh",
          width: "100vw",
          margin: 0,
        },
      }}
    >
      <DialogContent
        sx={{
          p: 0,
          m: 0,
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
          position: "relative",
        }}
      >
        {/* CLOSE ICON */}
        <IconButton
          onClick={handleClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            zIndex: 10,
            bgcolor: "background.paper",
            boxShadow: 1,
            "&:hover": { bgcolor: "grey.200" },
          }}
        >
          <CloseIcon />
        </IconButton>

        {/* FULL SCREEN CONTENT WRAPPER */}
        <Box
          sx={{
            height: "100%",
            width: "100%",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {children}
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default memo(AppModal);
